import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-a.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-a.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationAConstants } from "./create-application-location-a.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let CreateApplicationLocationAComponent = class CreateApplicationLocationAComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    mapTools;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    modalService;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    searchApplicationsService;
    displayMap = false;
    activeTabIndex;
    advertisementsForm;
    descriptionLabel1 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationAConstants.VALIDATION_MESSAGES;
    advertisementsFormGroupName = CreateApplicationLocationAConstants.ADVERTISEMENT_FORM_GROUP_NAME;
    advertisementsFormControlName = CreateApplicationLocationAConstants.ADVERTISEMENT_FORM_CONTROL_NAME;
    areaOfDisplayFormControlName = CreateApplicationLocationAConstants.AREA_OF_DISPLAY_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = CreateApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    layerReference = CreateApplicationLocationAConstants.LAYER_REFERENCE;
    applicationTypeFormControlName = CreateApplicationLocationAConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    typeLabel = CreateApplicationLocationAConstants.APPLICATION_TYPE_LABEL;
    streetNamesFormControl = CreateApplicationLocationAConstants.STREET_NAMES_FORM_CONTROL;
    propertyDescriptionFormControlName = CreateApplicationLocationAConstants.PROPERTY_DESCRIPTION_FORM_CONTROL_NAME;
    addressOrStreetFormControlName = CreateApplicationLocationAConstants.ADDRESS_OR_STREET_FORM_CONTROL_NAME;
    areaOfDisplayLabel = CreateApplicationLocationAConstants.AREA_OF_CONTROL_LABEL;
    streetNamesLabel = CreateApplicationLocationAConstants.STREET_NAMES_LABEL;
    propertyDescriptionLabel = CreateApplicationLocationAConstants.PROPERTY_DESCRIPTION_LABEL;
    addressOrStreetLabel = CreateApplicationLocationAConstants.ADDRESS_OR_STREET_LABEL;
    removeAdvertisementLabel = CreateApplicationLocationAConstants.REMOVE_ADVERTISEMENT_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = CreateApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    selectedAdvertisementType;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    areaOfDisplayLookups = LookupConstants.AREA_OF_DISPLAY_LOOKUPS_A;
    showPermanentApplicationsFields = false;
    showTemporaryApplicationsFields = false;
    permanentOrTemporaryLookupOptions = LookupConstants.PERMANENT_OR_TEMPORARY_LOOKUPS_A;
    applicationTypesLookupsOptions = [];
    applicationTypesLookups = [];
    showApplicationType = false;
    isMapLoaded = false;
    sketchTool;
    selectedGraphic = null;
    mapComponent;
    selectedPropertySubscription;
    getLookupsObservableSubscription;
    selectedApplicationBpamsSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    markStepFormGroupAsTouchedSubscription;
    constructor(applicationCreateService, mapTools, aflaModuleStrategyService, selectedApplicationService, appControllerService, modalService, mapService, requestStatusService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.mapTools = mapTools;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.aflaModuleStrategyService.lookups.has("applicationType")) {
            // application is coming from the application details step
            this.loadFormsAndData();
        }
        else {
            this.getLookups();
        }
        this.setupSubscriptions();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = false;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        this.resetSketchToolState();
    }
    mapLoaded(isMapLoaded) {
        if (!isMapLoaded) {
            return;
        }
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.initializeSketchTools();
    }
    loadMetadata() {
    }
    onPermanentOrTemporaryAdvertisementSelected($event) {
        const advertisementType = $event.target.value;
        const advertisementFormArray = this.getAdvertisements();
        this.loadMap();
        if (advertisementFormArray.length > 0) {
            this.confirmChangeFromUser(advertisementType);
            return;
        }
        this.handleAdvertisementTypeValueChanged(advertisementType);
    }
    getAdvertisements() {
        return this.advertisementsForm.get(this.advertisementsFormControlName);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getAdvertisements().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveFeature(featureIndex) {
        this.getAdvertisements().removeAt(featureIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.advertisementsForm = this.aflaModuleStrategyService.form.get(this.advertisementsFormGroupName);
        if (this.advertisementsForm.pristine) {
            this.advertisementsForm.enable();
            this.advertisementsForm.reset();
        }
    }
    setAdvertisementData(propertyObject, geometry) {
        try {
            this.requestStatusService.showBusySpinner("getAdvertisementData");
            let newAdvertisingFormGroup;
            if (propertyObject) {
                newAdvertisingFormGroup = this.setAdvertisingFormGroup(propertyObject, geometry);
            }
            else {
                newAdvertisingFormGroup = this.createAdvertisingFormGroup(geometry);
            }
            const url = this.getGPToolURL();
            const formData = this.getGPToolFormData(geometry);
            this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    this.showApplicationTypeField();
                    this.setApplicationValidators(newAdvertisingFormGroup);
                    this.setPropertyTrueCentroidData(newAdvertisingFormGroup, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("getAdvertisementData");
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("propertyData", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("getAdvertisementData");
                }
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("getAdvertisementData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getAdvertisements().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            try {
                this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
            }
            catch (e) {
                this.requestStatusService.removeBusySpinner("getAdvertisementData");
            }
        }
    }
    subscribeToAdvertisement() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                const objectId = this.featureDataAlternateColumnName(property.attributes, "OBJECTID", "objectId");
                const propertyHasAlreadyBeenAddedBefore = this.checkIfSelectedPropertyHasAlreadyBeenAdded(objectId);
                if (!propertyHasAlreadyBeenAddedBefore) {
                    this.setAdvertisementData(property.attributes, property.geometry);
                }
            }
        });
    }
    checkIfSelectedPropertyHasAlreadyBeenAdded(objectId) {
        let featureHasAlreadyBeenAddedBefore = false;
        this.getAdvertisements().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                featureHasAlreadyBeenAddedBefore = true;
                this.appControllerService.showMessage(CreateApplicationLocationAConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("add property");
            }
        });
        return featureHasAlreadyBeenAddedBefore;
    }
    featureDataAlternateColumnName(featureObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(featureObject)) {
            if (key === name1) {
                returnVal = featureObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = featureObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = featureObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setAdvertisingFormGroup(property, geometry) {
        return new FormGroup({
            objectId: new FormControl(this.featureDataAlternateColumnName(property, "OBJECTID", "objectId")),
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            type: new FormControl(null, Validators.required),
            propertyDescription: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    setPropertyTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const advertisementsArray = this.getAdvertisements();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        advertisementsArray?.clear();
        advertisementsArray.push(newFormGroup);
        this.activeTabIndex = advertisementsArray.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    setApplicationValidators(formGroup) {
        formGroup.get(this.applicationTypeFormControlName).setValidators(Validators.required);
        formGroup.updateValueAndValidity();
        if (this.selectedAdvertisementType?.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.addTemporaryAdvertisementFieldsValidators(formGroup);
        }
        if (this.selectedAdvertisementType?.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.addPermanentAdvertisementFieldsValidators(formGroup);
        }
        formGroup.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    handleTemporaryApplicationSelected() {
        this.showPermanentApplicationsFields = false;
        this.showTemporaryApplicationsFields = true;
    }
    handlePermanentApplicationSelected() {
        this.showPermanentApplicationsFields = true;
        this.showTemporaryApplicationsFields = false;
    }
    initializeSketchTools() {
        const drawTool = this.mapTools.getMapTool(CreateApplicationLocationAConstants.DRAW_TOOL_NAME);
        if (!drawTool) {
            return;
        }
        const hasSketchToolChanged = this.sketchTool !== drawTool;
        this.sketchTool = drawTool;
        this.mapTools.expandWidget(CreateApplicationLocationAConstants.DRAW_TOOL_NAME);
        if (hasSketchToolChanged) {
            this.registerSketchToolCreateHandler();
        }
        this.configureSketchToolForSelectedAdvertisementType();
    }
    registerSketchToolCreateHandler() {
        // Re-register only when a new Sketch instance is created for a new map.
        this.sketchTool.on("create", (event) => {
            if (event.state === "complete") {
                this.handleSketchComplete(event);
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    handleSketchComplete(event) {
        this.selectedGraphic = event.graphic;
        this.setAdvertisementData(null, this.selectedGraphic.geometry);
    }
    createAdvertisingFormGroup(geometry) {
        return new FormGroup({
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            type: new FormControl(null, Validators.required),
            propertyDescription: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    setMapToolsForTemporaryAdvertisement() {
        this.sketchTool.create("polygon");
        this.sketchTool.visibleElements = CreateApplicationLocationAConstants.POLYGON_SKETCH_TOOLS_OPTIONS;
    }
    setMapToolsForPermanentAdvertisement() {
        this.sketchTool.create("point");
        this.sketchTool.visibleElements = CreateApplicationLocationAConstants.POINT_SKETCH_TOOLS_OPTIONS;
    }
    confirmChangeFromUser(advertisementType) {
        const dialogRef = this.modalService.open(PopUpComponent, CreateApplicationLocationAConstants.MODAL_OPTIONS);
        dialogRef.componentInstance.title = CreateApplicationLocationAConstants.MODAL_DIALOG_TITLE;
        dialogRef.componentInstance.contentMessage = CreateApplicationLocationAConstants.MODAL_DIALOG_MESSAGE;
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((canContinueMakingChanges) => {
            if (canContinueMakingChanges) {
                this.resetLocationDetails();
                this.handleAdvertisementTypeValueChanged(advertisementType);
                // if (this.selectedApplication && this.selectedApplication.id > 0) {
                //     this.clearApplicationValues(this.selectedApplication.id);
                // }
            }
            else {
                this.selectedAdvertisementType = advertisementType.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE
                    ? CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE
                    : CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE;
            }
        });
    }
    resetLocationDetails() {
        this.showPermanentApplicationsFields = false;
        this.showTemporaryApplicationsFields = false;
        this.mapComponent.removeGraphicsFromMap(this.layerReference);
        const advertisementsArray = this.getAdvertisements();
        advertisementsArray.clearValidators();
        advertisementsArray.clear();
        this.changeDetectorRefs.detectChanges();
    }
    handleAdvertisementTypeValueChanged(advertisementType) {
        this.updateSelectedAdvertisementTypeState(advertisementType);
        this.configureSketchToolForSelectedAdvertisementType();
    }
    updateSelectedAdvertisementTypeState(advertisementType) {
        if (!advertisementType) {
            return;
        }
        this.selectedAdvertisementType = advertisementType;
        this.filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType);
    }
    configureSketchToolForSelectedAdvertisementType() {
        if (!this.sketchTool || !this.selectedAdvertisementType) {
            return;
        }
        const normalizedAdvertisementType = this.selectedAdvertisementType.toLowerCase();
        if (normalizedAdvertisementType === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.setMapToolsForTemporaryAdvertisement();
            return;
        }
        if (normalizedAdvertisementType === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.setMapToolsForPermanentAdvertisement();
        }
    }
    showMap() {
        this.displayMap = true;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                this.onGetLookupsCompleted(lookups);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("Lookups", error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(lookups) {
        this.applicationTypesLookupsOptions = [];
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypesLookups.push(lookUpContent);
            }
        });
        this.aflaModuleStrategyService.lookups.set("applicationType", this.applicationTypesLookups);
        // if (!this.aflaModuleStrategyService.form.pristine && this.aflaModuleStrategyService.form.touched) {
        if ((this.selectedApplication && this.selectedApplication.polygon) || (this.selectedApplication && this.selectedApplication.point)) {
            // check using polygon or point as it is impossible to move past the first step without saving one or the other
            // if application has either point or polygon saved then it is not a new application, continue to retrieve previously save data
            // this.checkApplicationData();
            this.onGetApplicationDataCompleted(this.selectedApplication);
        }
        this.changeDetectorRefs.detectChanges();
    }
    addTemporaryAdvertisementFieldsValidators(newAdvertisingFormGroup) {
        newAdvertisingFormGroup.get(this.areaOfDisplayFormControlName).addValidators(Validators.required);
        newAdvertisingFormGroup.get(this.streetNamesFormControl).addValidators(Validators.required);
        newAdvertisingFormGroup.get(this.propertyDescriptionFormControlName).addValidators(Validators.required);
    }
    addPermanentAdvertisementFieldsValidators(newAdvertisingFormGroup) {
        newAdvertisingFormGroup.get(this.addressOrStreetFormControlName).addValidators(Validators.required);
    }
    setupSubscriptions() {
        this.subscribeToAdvertisement();
        this.subscribeToClearGraphics();
        this.subscribeToCheckFormValidity();
        // this.subscribeToSelectedApplication();
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getAdvertisements().clear();
                    if (this.mapComponent) {
                        this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    }
                    if (this.mapTools.sketchGraphicsLayer) {
                        this.mapTools.sketchGraphicsLayer.removeAll();
                    }
                    this.advertisementsForm.reset();
                    this.showPermanentApplicationsFields = false;
                    this.showTemporaryApplicationsFields = false;
                    this.resetSketchToolState();
                    this.displayMap = false;
                    this.hideApplicationTypeField();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType) {
        if (advertisementType.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.applicationTypesLookupsOptions = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE)) {
                    this.applicationTypesLookupsOptions.push(applicationType);
                }
            });
            this.applicationTypesLookupsOptions.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
        if (advertisementType.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.applicationTypesLookupsOptions = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE)) {
                    this.applicationTypesLookupsOptions.push(applicationType);
                }
            });
            this.applicationTypesLookupsOptions.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
    }
    checkApplicationData() {
        const isFormPristine = this.advertisementsForm.pristine;
        const isFormUnTouched = this.advertisementsForm.untouched;
        const isFormInvalid = this.advertisementsForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid && this.selectedApplication) {
            this.onGetApplicationDataCompleted(this.selectedApplication);
        }
    }
    onGetApplicationDataCompleted(selectedApplication) {
        this.updateSelectedAdvertisementTypeState(selectedApplication.isAdvetisingPermanentOrTemporary);
        this.loadMap();
        this.setComponentData(selectedApplication);
    }
    setComponentData(selectedApplication) {
        const advertisementControl = this.getAdvertisements();
        let point;
        let polygon;
        const isAdvertisingPermanentOrTemporaryValue = selectedApplication.isAdvetisingPermanentOrTemporary;
        if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            point = selectedApplication.point;
        }
        if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            polygon = selectedApplication.polygon;
        }
        const isTemporaryAdvertisement = isAdvertisingPermanentOrTemporaryValue.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE;
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(isTemporaryAdvertisement ? polygon.shape : point.shape, 102100);
        const geom = JsonUtils.fromJSON(geometryArc);
        const updatedAdvertisementFormGroup = this.getUpdatedAdvertisementFormGroup(selectedApplication, geom);
        this.advertisementsForm.markAllAsTouched();
        this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
            next: (trueCentroidResponse) => {
                this.setAdvertisementType();
                this.showApplicationTypeField();
                this.changeDetectorRefs.detectChanges();
                this.setApplicationType(updatedAdvertisementFormGroup);
                CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, updatedAdvertisementFormGroup);
                this.setApplicationValidators(updatedAdvertisementFormGroup);
                advertisementControl.push(updatedAdvertisementFormGroup);
                this.activeTabIndex = advertisementControl.length - 1;
                if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
                    this.handlePermanentApplicationSelected();
                }
                if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
                    this.handleTemporaryApplicationSelected();
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationLocationAConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    getUpdatedAdvertisementFormGroup(selectedApplication, geom) {
        return new FormGroup({
            areaOfDisplay: new FormControl(selectedApplication.polygon?.areaOfDisplay),
            streetNames: new FormControl(selectedApplication.polygon?.streetNames),
            propertyDescription: new FormControl(selectedApplication.polygon?.propertyDescription),
            streetOrAddress: new FormControl(selectedApplication.frontalArea),
            addressStreetInformation: new FormControl(selectedApplication.point?.addressStreetInformation),
            type: new FormControl(selectedApplication.type, Validators.required),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    loadMap() {
        if (this.displayMap) {
            return;
        }
        this.showMap();
        this.changeDetectorRefs.detectChanges();
    }
    showApplicationTypeField() {
        this.showApplicationType = true;
    }
    hideApplicationTypeField() {
        this.showApplicationType = false;
    }
    onApplicationTypeSelected($event) {
        const selectedApplicationType = $event.target.value;
        const advertisementType = this.advertisementsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).value;
        this.advertisementsForm.get(this.applicationTypeFormControlName).setValue(selectedApplicationType);
        const advertisingFormArray = this.advertisementsForm.get("advertisements");
        const selectedAdvertisementFormGroup = advertisingFormArray.controls[0];
        const applicationTypeControl = selectedAdvertisementFormGroup.get(this.applicationTypeFormControlName);
        applicationTypeControl.setValue(selectedApplicationType);
        applicationTypeControl.updateValueAndValidity();
        if (advertisementType?.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.handlePermanentApplicationSelected();
        }
        if (advertisementType?.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.handleTemporaryApplicationSelected();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationBpamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.setComponentData(this.selectedApplication);
            }
        });
    }
    setAdvertisementType() {
        const isAdvertisingPermanentOrTemporaryValue = this.selectedApplication.isAdvetisingPermanentOrTemporary;
        this.updateSelectedAdvertisementTypeState(isAdvertisingPermanentOrTemporaryValue);
        this.advertisementsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).setValue(isAdvertisingPermanentOrTemporaryValue);
        this.configureSketchToolForSelectedAdvertisementType();
    }
    setApplicationType(updatedAdvertisementFormGroup) {
        const applicationTypeValue = this.selectedApplication.type;
        const applicationTypeControl = updatedAdvertisementFormGroup.get(this.applicationTypeFormControlName);
        this.advertisementsForm.get(this.applicationTypeFormControlName).setValue(applicationTypeValue);
        applicationTypeControl.setValue(applicationTypeValue);
    }
    loadFormsAndData() {
        // set application type dropdowns
        this.applicationTypesLookups = this.aflaModuleStrategyService.lookups.get("applicationType");
        // set various form data
        this.setAdvertisementType();
        this.loadMap();
        this.showApplicationTypeField();
        this.changeDetectorRefs.detectChanges();
        if (this.selectedApplication.isAdvetisingPermanentOrTemporary?.toLowerCase() === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.handlePermanentApplicationSelected();
        }
        if (this.selectedApplication.isAdvetisingPermanentOrTemporary?.toLowerCase() === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.handleTemporaryApplicationSelected();
        }
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries();
    }
    resetSketchToolState() {
        this.isMapLoaded = false;
        this.selectedGraphic = null;
        this.sketchTool = null;
    }
    subscribeToCheckFormValidity() {
        this.markStepFormGroupAsTouchedSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.advertisementsForm && formGroupName === this.advertisementsFormGroupName) {
                    this.advertisementsForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: MapTools },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: false },] }]
    };
};
CreateApplicationLocationAComponent = __decorate([
    Component({
        selector: "app-create-application-location-a",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationAComponent);
export { CreateApplicationLocationAComponent };
